import { _ as _extends } from '../../extends-30811c5e.js';
import { _ as _defineProperty } from '../../defineProperty-6f298737.js';
import { _ as _objectWithoutProperties } from '../../objectWithoutProperties-dd908bcc.js';
import React__default from 'react';
import classNames from 'classnames';

var _excluded = ["highlightColor", "size", "className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

/* eslint-disable @typescript-eslint/no-unused-vars */

var IconStreakSaver = function IconStreakSaver(_ref) {
  _ref.highlightColor;
    var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 16 : _ref$size,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    newProps = _objectWithoutProperties(_ref, _excluded);
  var props = _objectSpread(_objectSpread({
    width: size,
    height: size
  }, newProps), {}, {
    className: classNames('sol-icon', className)
  });
  return /*#__PURE__*/React__default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), /*#__PURE__*/React__default.createElement("g", {
    id: "icon-streak-saver"
  }, /*#__PURE__*/React__default.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8967 22.3136C11.9669 22.3245 12.0436 22.33 12.1268 22.33C12.4202 22.2821 12.5627 22.2602 12.5543 22.2644C14.9522 21.5418 16.9193 20.0685 18.4556 17.8444C19.9918 15.6203 20.76 13.1812 20.76 10.527V5.38406C20.76 5.00241 20.6503 4.65481 20.4309 4.34126C20.2115 4.0277 19.9287 3.80283 19.5823 3.66666L12.7585 1.11851C12.5391 1.0395 12.3286 1 12.1268 1C11.9251 1 11.7145 1.0395 11.4951 1.11851L4.67134 3.66666C4.32499 3.80283 4.04318 4.0277 3.82591 4.34126C3.60864 4.65481 3.5 5.00241 3.5 5.38406V10.527C3.5 13.1812 4.26708 15.6203 5.80124 17.8444C7.33542 20.0685 9.30146 21.5418 11.6994 22.2644C11.7607 22.2863 11.8265 22.3027 11.8967 22.3136ZM7.76774 11.008C7.09559 11.008 6.77425 10.1819 7.26973 9.72768L12.89 4.57558C13.4303 4.08026 14.2838 4.59171 14.1019 5.30181L12.6401 11.008H15.7704C16.4425 11.008 16.7639 11.8341 16.2684 12.2883L10.6482 17.4404C10.1078 17.9358 9.25429 17.4243 9.4362 16.7142L10.8981 11.008H7.76774Z",
    fill: "currentColor"
  })));
};

export { IconStreakSaver };
